import { render } from "./TablePagination.vue?vue&type=template&id=06e74fc6&scoped=true"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"

import "./TablePagination.vue?vue&type=style&index=0&id=06e74fc6&lang=scss&scoped=true"
import "./TablePagination.vue?vue&type=style&index=1&id=06e74fc6&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e74fc6"]])

export default __exports__